import "core-js/modules/es6.function.name";
import "core-js/modules/es6.array.find";
import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import AddLeave from "@/views/management/advice/addLeave";
import { getServeDetail } from "@/api/serveCenter/serveCenter";
import { handleserveFileDownload } from "@/api/managementCenter/otherApi";
import { favorOrRecall as _favorOrRecall } from "@/api/serveCenter/serveCenter";
import IframeView from "@/components/public/IframeView.vue";
import { bpmnStartProcess } from "@/api/bpmnApi/bpmn";
export default {
  name: "ServeCenterDetail",
  components: {
    AddLeave: AddLeave,
    IframeView: IframeView
  },
  props: [],
  data: function data() {
    return {
      loading: false,
      policyShow: false,
      policyShowContent: "",
      resData: {},
      onlineDesc: {},
      offlineDesc: {},
      lineFileList: [],
      processImg: {},
      messageList: [],
      rationsStatistics: {},
      policy: [],
      fixName: "",
      leftNavList: [{
        text: "流程信息",
        key: "lcxx"
      }, {
        text: "办理方式",
        key: "blfs"
      }, {
        text: "办理材料",
        key: "blcl"
      }, {
        text: "办理流程",
        key: "bllc"
      }, {
        text: "设定依据",
        key: "sdyj"
      }, {
        text: "注意事项",
        key: "zysx"
      }, {
        text: "常见问题",
        key: "cjwt"
      }, {
        text: "留言与回复",
        key: "lyyhf"
      }, {
        text: "服务评价",
        key: "fwpj"
      }]
    };
  },
  computed: {},
  created: function created() {},
  mounted: function mounted() {
    this.getServeDetailFn();
  },
  methods: {
    HandleApply: function HandleApply() {
      var _this = this;

      var processDefId = this.resData.processDefId;
      bpmnStartProcess({
        processDefId: processDefId
      }).then(function (_ref) {
        var data = _ref.data;

        if (data.code == 0) {
          console.log(data);
          window.sessionStorage.setItem("processInstId", data.data.processInstId);

          _this.$refs.IframeView.showView(data.data.url, data.data.taskInstId);
        } else {
          _this.$message.warning(data.msg || "流程系统业务忙，请刷新或者重新操作");
        }
      }).catch(function (err) {
        _this.$message.error("服务异常");
      });
    },
    favorOrRecall: function favorOrRecall(item) {
      var _this2 = this;

      var params = {
        isFavor: !item.tagType ? true : false,
        serveId: item.serveId
      };
      this.loading = true;

      _favorOrRecall(params).then(function (_ref2) {
        var data = _ref2.data;
        _this2.loading = false;

        if (data.code == 0) {
          _this2.$message.success(!item.tagType ? "收藏成功!" : "取消收藏成功!");

          item.tagType = item.tagType ? null : true;
        } else {
          _this2.$message.warning(data.msg || "操作失败!");
        }
      }).catch(function (err) {
        _this2.loading = false;
      });
    },
    goScroll: function goScroll(idName) {
      var _this3 = this;

      window.scrollTo(0, document.getElementById(idName).offsetTop - 180);
      setTimeout(function () {
        _this3.fixName = idName;
      }, 200);
    },
    initLeftNavBar: function initLeftNavBar() {
      var _this4 = this;

      var scrollTop = document.documentElement.scrollTop;
      this.leftNavList.forEach(function (item, index) {
        var offsetop = document.getElementById(item.key).offsetTop;

        if (index = _this4.leftNavList.length - 1) {
          if (offsetop - 180 < scrollTop) {
            _this4.fixName = item.key;
            return;
          }
        } else {
          if (index == 0) {
            var offsetopNext = document.getElementById(_this4.leftNavList[index + 1].key).offsetTop;

            if (0 < scrollTop && scrollTop < offsetopNext - 185) {
              _this4.fixName = item.key;
              return;
            }
          } else {
            var _offsetopNext = document.getElementById(_this4.leftNavList[index + 1].key).offsetTop;

            if (offsetop - 185 < scrollTop && scrollTop < _offsetopNext - 185) {
              _this4.fixName = item.key;
              return;
            }
          }
        }
      });
    },
    getServeDetailFn: function getServeDetailFn() {
      var _this5 = this;

      this.loading = true;
      getServeDetail(this.$route.query.id).then(function (_ref3) {
        var data = _ref3.data;
        _this5.loading = false;

        if (data.code == 0) {
          _this5.resData = data.data || {};
          _this5.onlineDesc = JSON.parse(_this5.resData.onlineDesc);
          _this5.offlineDesc = JSON.parse(_this5.resData.offlineDesc);
          _this5.lineFileList = _this5.getlineFileList(_this5.resData.fileList);
          _this5.policy = _this5.resData.policy ? JSON.parse(_this5.resData.policy) : [];
          _this5.processImg = (_this5.resData.fileList || []).find(function (i) {
            return i.fileType == "1";
          });
          _this5.rationsStatistics = _this5.resData.rationsStatistics || {};
          _this5.messageList = (_this5.resData.messageList || []).filter(function (i) {
            return i.privateFlag == 1;
          });

          _this5.$nextTick(function () {
            window.addEventListener("scroll", _this5.initLeftNavBar);

            _this5.initLeftNavBar();
          });
        } else {
          _this5.$message.warning(data.msg || "获取服务信息失败！");
        }
      }).catch(function (err) {
        _this5.loading = false;
      });
    },
    goAddLeave: function goAddLeave() {
      this.$refs.addLeave.dialogShow(this.$route.query.id, this.resData.serveName);
    },
    saveSuccess: function saveSuccess() {
      this.getServeDetailFn();
    },
    downLoadFile: function downLoadFile(item) {
      var _this6 = this;

      this.$DownLoad(handleserveFileDownload(item.fileId), null, function (res) {
        if (res.status == 200) {} else {
          _this6.$alert("下载出错,请稍后重试", "提示", {
            confirmButtonText: "确定",
            type: "warning"
          });
        }
      }, function (error) {
        _this6.$alert(error, "提示", {
          confirmButtonText: "确定",
          type: "warning"
        });
      });
    },
    downloadImg: function downloadImg(url) {
      var a = document.createElement("a");
      var event = new MouseEvent("click");
      a.href = url;
      a.dispatchEvent(event);
    },
    getlineFileList: function getlineFileList(arr) {
      var list = arr || [];
      var filtlist = list.filter(function (item) {
        return item.fileType == "3" || item.fileType == "4";
      });
      return filtlist;
    },
    seePolicyContent: function seePolicyContent(pro) {
      this.policyShow = true;
      this.policyShowContent = pro.content;
    },
    previewFileFn: function previewFileFn(item) {
      var routeData = this.$router.resolve({
        name: "/previewFilePage",
        query: {
          fileUrl: item.fileUrl
        }
      });
      window.open(routeData.href);
    }
  },
  destroyed: function destroyed() {
    window.removeEventListener("scroll", this.initLeftNavBar);
  },
  watch: {},
  filters: {
    formatApplyType: function formatApplyType(val) {
      var obj = {
        1: "线上",
        2: "线上",
        3: "线上和线下"
      };
      return obj[val + ""];
    },
    policyTypeFilter: function policyTypeFilter(val) {
      var policyType = [{
        name: "请选择",
        value: ""
      }, {
        name: "国家法规",
        value: "1"
      }, {
        name: "地方法规",
        value: "2"
      }, {
        name: "行政法规",
        value: "3"
      }, {
        name: "学校政策",
        value: "4"
      }, {
        name: "部门规章",
        value: "5"
      }, {
        name: "其他",
        value: "6"
      }];
      var obj = policyType.find(function (i) {
        return val == i.value;
      });

      if (obj) {
        return obj.name;
      } else {
        return "";
      }
    }
  }
};